export default __webpack_public_path__ + "static/media/features-top-image.953264a0.png";